/* Bloom: Safe mega menu image cards
 * Restores desktop menu thumbnails without page-wide hover swapping or MutationObserver loops.
 */
(function() {
  'use strict';

  if (window.innerWidth < 1000) return;

  var menus = {
    htb_oral_care: {
      imageClass: 'bloom-product-img',
      items: {
        '/products/natural-mouth-wash': {
          title: 'Restorative Mouth Rinse',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/btl-front.png?v=1662555650&width=300'
        },
        '/products/natural-toothpaste': {
          title: 'Living Crystal Toothpaste',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/boxl-back-2.png?v=1667466631&width=300'
        },
        '/products/ozonated-oil-pull': {
          title: 'Ozonated Oil Pull',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/OzonatedOilPull-1a.png?v=1732049952&width=300'
        },
        '/products/antioxidant-oil-pull': {
          title: 'Antioxidant Oil Pull',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/71yfrGiv8mL._AC_SL1500.jpg?v=1776312952&width=300'
        },
        '/products/bamboo-toothbrush': {
          title: 'Bamboo Toothbrush',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/bamboo-toothbrush-card.png?v=1786139355&width=300'
        }
      }
    },
    htb_household: {
      imageClass: 'bloom-product-img',
      items: {
        '/products/counter-defense-multi-surface-cleaner': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/Website_New_product_page_image_17-Counter_Defense_Front_noback.png?v=1&width=400'
        },
        '/products/pristine-clean-bioactive-dish-soap': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/Website_New_product_page_image_21-Dish_Soap_Front__noback.png?v=1&width=400'
        },
        '/products/rinse-away-fruit-and-veggie-wash': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/Website_New_product_page_image_19-Rinse_Away_Front_noback.png?v=1&width=400'
        }
      }
    },
    htb_face: {
      imageClass: 'bloom-product-img',
      items: {
        '/products/active-twilight-face-cream': {
          title: 'Active Twilight Face Cream',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/active-twilight-img01.jpg?v=1780063337&width=300'
        },
        '/products/complete-daily-face-moisturizer': {
          title: 'Complete Daily Face Moisturizer',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/page-01.jpg?v=1779763313&width=300'
        },
        '/products/dynamic-hydrogel-face-serum': {
          title: 'Dynamic Hydrogel Face Serum',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/dynamic-hydrogel-face-serum-01_3caccb15-df17-464b-933c-afd070083f39.jpg?v=1779368222&width=300'
        },
        '/products/island-mist-toning-facial-elixir-hydrosol': {
          title: 'Island Mist Toning Facial Elixir',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/island-mist-toning-facial-elixir-hydrosol.png?v=1778270449&width=300'
        },
        '/collections/facial-care': {
          title: 'View All Face Care',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/collections/sapphire-collection-banner.png?v=1781120657&width=300'
        }
      }
    },
    htb_hair: {
      imageClass: 'bloom-product-img',
      items: {
        '/products/roots-locks-moisturizing-revival-shampoo': {
          title: 'Roots & Locks Moisturizing Revival Shampoo',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/New_Product_Page_Web_Images_Roots_and_Locks_shampoo.001---7926fb94-9130-4b26-9e6d-b5a787c04164.png?v=1780159807&width=300'
        },
        '/products/roots-locks-moisturizing-revival-conditioner': {
          title: 'Roots & Locks Moisturizing Revival Conditioner',
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/New_Product_Page_Web_Images_Roots_and_Locks_conditioner.001---d4f7608a-97dd-419b-88b7-af689c304d51.png?v=1780160445&width=300'
        }
      }
    },
    htb_combos: {
      imageClass: 'bloom-product-img',
      byText: true,
      items: {
        'Oral Care Kits': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/PureBreeze.png?v=1667984482&width=400'
        },
        'Body Care Kits': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/TheCastaway.png?v=1667984533&width=400'
        },
        'Soap Kits': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/SandBar.png?v=1667984571&width=400'
        },
        'Household Kits': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/Home_Country.png?v=1667984722&width=400'
        },
        'Browse All Kits': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/products/Hurricane.png?v=1667984696&width=400'
        }
      }
    },
    htb_our_journey: {
      imageClass: 'bloom-journey-icon',
      byText: true,
      panelClass: 'bloom-journey-menu',
      items: {
        'Our Journey': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/bloom-icon-our-journey-v2.png?v=1776212330&width=480'
        },
        'Our Ingredients': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/bloom-icon-our-ingredients-v2.png?v=1776212331&width=480'
        },
        'Our Blog': {
          image: 'https://cdn.shopify.com/s/files/1/0354/7083/5756/files/bloom-icon-our-blog-v2.png?v=1776212332&width=480'
        }
      }
    }
  };

  function normalizePath(href) {
    var a = document.createElement('a');
    a.href = href || '';
    return a.pathname.replace(/\/$/, '');
  }

  function injectMenu(menuId, config) {
    var panel = document.getElementById('mega-menu-' + menuId);
    if (!panel) return false;
    if (config.panelClass) panel.classList.add(config.panelClass);

    var changed = false;
    var headings = panel.querySelectorAll('.htb-mega-menu__heading');
    headings.forEach(function(heading) {
      var key = config.byText ? heading.textContent.trim() : normalizePath(heading.getAttribute('href'));
      var item = config.items[key];
      if (!item) return;

      var titleText = item.title || heading.textContent.trim();
      var img = heading.querySelector('.' + config.imageClass);
      if (!img) {
        img = document.createElement('img');
        img.className = config.imageClass;
        img.loading = 'eager';
        heading.insertBefore(img, heading.firstChild);
        changed = true;
      }

      if (img.getAttribute('src') !== item.image) {
        img.src = item.image;
        changed = true;
      }
      if (img.getAttribute('alt') !== titleText) img.alt = titleText;

      if (menuId === 'htb_oral_care') {
        var label = heading.querySelector('.bloom-product-title') || heading.querySelector('.reversed-link');
        if (!label) {
          label = document.createElement('span');
          heading.appendChild(label);
        }
        label.classList.add('bloom-product-title');
        if (label.textContent.trim() !== titleText) label.textContent = titleText;
      }
    });

    return changed;
  }

  function injectAll() {
    Object.keys(menus).forEach(function(menuId) {
      injectMenu(menuId, menus[menuId]);
    });
  }

  function preload() {
    Object.keys(menus).forEach(function(menuId) {
      var items = menus[menuId].items;
      Object.keys(items).forEach(function(key) {
        var img = new Image();
        img.src = items[key].image;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAll, { once: true });
  } else {
    injectAll();
  }

  document.addEventListener('toggle', function(event) {
    if (!event.target || event.target.tagName !== 'DETAILS' || !event.target.open) return;
    window.setTimeout(injectAll, 50);
  }, true);

  document.addEventListener('mouseover', function(event) {
    if (!event.target || !event.target.closest || !event.target.closest('header')) return;
    window.setTimeout(injectAll, 50);
  }, true);

  document.addEventListener('focusin', function(event) {
    if (!event.target || !event.target.closest || !event.target.closest('header')) return;
    window.setTimeout(injectAll, 50);
  }, true);

  window.addEventListener('load', injectAll, { once: true });
  window.setTimeout(injectAll, 400);
  preload();
})();
